import { lazy } from "react";
import { FeatureFlagRoute } from "../../_features/featureFlags/routing/FeatureFlagRoute";
import PermissionRoute from "./PermissionRoute";
import { ROUTE_PERMISSIONS } from "./routePermissions";
import { paths } from "./paths";

const CompanyPageFeature = lazy(() => import("../../_features/company/pages/CompanyPage"));
const CompanyDetailsFeature = lazy(() => import("../../_features/company/pages/CompanyDetails"));

export const companyRoutes = [
    {
        path: paths.company,
        element:
            <FeatureFlagRoute feature="companies">
                <PermissionRoute permission={ROUTE_PERMISSIONS.company.view} moduleName="Companies">
                    <CompanyPageFeature />
                </PermissionRoute>
            </FeatureFlagRoute>
    },
    {
        path: "/company/:id",
        element:
            <FeatureFlagRoute feature="companies">
                <PermissionRoute permission={ROUTE_PERMISSIONS.company.view} moduleName="Companies">
                    <CompanyDetailsFeature />
                </PermissionRoute>
            </FeatureFlagRoute>
    }
];
